<template>
  <tr height=20px>
    <td v-if="file.type == 'FILE'">
      <a href="#" @click="downloadFile(file)">{{ file.name }}</a>
    </td>
    <td v-else>
      {{ file.name }}
    </td>

    <td>{{ file.type }}</td>

    <td><template v-if="file.type == 'FILE'">{{ file.size }} ({{ file.human_size }})</template></td>

    <td>{{ file.human_date }}</td>

    <td v-if="file.name == '..'">
      <button type="button" class="btn btn-sm btn-success" style="margin-right: 5px" @click="enterDir(file.name)">Back</button>
    </td>
    <td v-else>
      <button :disabled="deleting" type="button" class="btn btn-sm btn-danger" style="margin-right: 5px; width: 110px" @click="removeFile(file)">
        <Spinner v-if="deleting" height="15px" margin_right="20px"></Spinner> Delete
      </button>
      <button type="button" class="btn btn-sm btn-primary" style="margin-right: 5px; width: 110px" v-if="file.type == 'DIR'" @click="enterDir(file.name)">Enter</button>
      <button :disabled="previewing" type="button" class="btn btn-sm btn-primary" style="width: 110px" v-if="(!preview) && (!file.data) && file.type == 'FILE'" @click="previewFile(file)">
        <Spinner v-if="previewing" height="15px" margin_right="20px"></Spinner> Preview
      </button>
    </td>

    <td>
      <img v-if="preview" :src="preview" />
      <span v-else>
        {{ file.data }}
      </span>
    </td>
  </tr>
</template>

<script lang="ts">
import BaseComponent from '@/components/Base.vue';
import FileSaver from 'file-saver';
import { defineComponent, type PropType } from "vue";
import { type Row } from '@/ts/types';

export default defineComponent({
  extends: BaseComponent,
  data() {
    return {
      deleting: false,
      previewing: false,
      preview: '',
    };
  },
  props: {
    file: { required: true, type: Object as PropType<Row> },
    currentDirHandle: { required: true, type: Object as PropType<FileSystemDirectoryHandle> },
    previewAllFiles: { required: true, type: Boolean }
  },
  watch: {
    previewAllFiles(newValue: boolean) {
      if (newValue && (!this.preview) && (!this.file.data) && this.file.type == 'FILE') {
        this.previewFile(this.file);
      }
    }
  },
  methods: {
    async previewFile(row: Row) {
      this.previewing = true;
      try {
        const fileHandle = await this.currentDirHandle.getFileHandle(row.name, { create: false });
        const file = await fileHandle.getFile();
        const src = URL.createObjectURL(file);
        this.preview = src;
      } catch {

      } finally {
        this.previewing = false;
      }
    },
    async downloadFile(row: Row) {
      const fileHandle = await this.currentDirHandle.getFileHandle(row.name, { create: false });
      const file = await fileHandle.getFile();
      FileSaver.saveAs(file, row.name);
    },
    sortFiles(a: Row, b: Row) {
      if (a.name == '..') {
        return -1;
      }
      if (b.name == '..') {
        return 1;
      }
      if ((a.type == 'DIR') && (b.type == 'FILE')) {
        return -1;
      }
      if ((b.type == 'DIR') && (a.type == 'FILE')) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      } else {
        return 1;
      }
    },
    async removeFile(file: Row) {
      let message = 'Are you sure to delete file: ' + file.name + '?';
      if (file.type == 'DIR') {
        message = 'Are you sure to delete directory: ' + file.name + '?';
      }
      const areYouSure = window.confirm(message);
      if (areYouSure) {
        this.deleting = true;
        if (file.type == 'FILE') {
          const fileHandle = await this.currentDirHandle.getFileHandle(file.name, { create: false });
          await fileHandle.remove();
        } else {
          const fileHandle = await this.currentDirHandle.getDirectoryHandle(file.name, { create: false });
          await fileHandle.remove({ recursive: true });
        }
        this.deleting = false;
        this.$emit('deletefile', file);
      }
    },
    enterDir(dirname: string) {
      this.$emit('enterdir', dirname);
    },
  }
})

</script>